import { Box, Flex, Grid, Text } from "@chakra-ui/react";
import api from "api/api";
import { GetLayout } from "components/get-layout";
import { ServiceCard } from "components/servicos-components/service-card";
import {
  BankBgIcon,
  CardBgIcon,
  DocumentBgIcon,
  PhoneBgIcon,
  TalkBallonBgIcon,
} from "components/servicos-components/service-card/icons";
import { ModalAtivoStatus } from "components/servicos-components/service-card/modal-ativo-status";
import { ModalChangeCobranca } from "components/servicos-components/service-card/modal-change-cobranca";
import { WhatsAppServiceCard } from "components/servicos-components/service-card/whatsapp-service-card";
import { PartnersSearch } from "components/carteira-components/modal-partners-search";
import { useApplicationContext } from "contexts/ApplicationContext";
import { SelectedCustomer } from "pages/carteira";
import { useEffect, useState } from "react";
import { MargemConvênioServiceCard } from "components/servicos-components/service-card/margem-convenio-card";
import { SimulacaoFGTSServiceCard } from "components/servicos-components/service-card/simulacao-fgts";
import apiCarteira from "api/api-carteira";
import { Toast } from "components/toast";
import { VendeAICard } from "components/servicos-components/service-card/vende-ai-card";
import { InputField } from "components/input-field";
import { IconButtonWithLoading } from "components/mailing-components/mailing-table/icon-button-with-loading";
import { CopyIcon } from "@chakra-ui/icons";
import { ServicesProps } from "./types";

export function ServicosPage() {
  const [selectedCustomer, setSelectedCustomer] = useState<SelectedCustomer>({
    id: -1,
    name: "",
    codigoNova: "",
    cashback: "PENDING",
  });
  const [serviceData, setServiceData] = useState<any>({});
  const [cardData, setCardData] = useState<Partial<ServicesProps>>({});
  const { user } = useApplicationContext();
  const [isLoading, setIsLoading] = useState<any>(false);
  const [loadingApiCarteira, setLoadingAPICarteira] = useState(false);
  const [link, setLink] = useState("");
  const [loadingLink, setLoadingLink] = useState(false);

  const params = new URLSearchParams(window.location.search);
  const partnerId = params.get("partnerId");

  const getDataAPICarteira = async (id: number) => {
    setLoadingAPICarteira(true);
    try {
      const { data } = await apiCarteira.get(`/services?customer_id=${id}`);
      setCardData(data);
      return data;
    } catch (e) {
      Toast({ title: "Erro ao obter dados", status: "error" });
    } finally {
      setLoadingAPICarteira(false);
    }
  };

  const loadServices = async ({
    id,
    ...rest
  }: Partial<SelectedCustomer> = {}) => {
    setIsLoading(true);
    try {
      const { data } = await api.get(`/services?customerId=${id}`);
      const dataApiCarteira = await getDataAPICarteira(id!);
      setSelectedCustomer({ id, ...rest } as SelectedCustomer);
      setServiceData({
        ...data,
        servicesAPICartaoBancoDTO: dataApiCarteira.servicesAPICartaoBancoDTO,
        servicesDatafast: dataApiCarteira.servicesDatafast,
      });
    } catch (e) {
      Toast({ title: "Erro ao obter serviços", status: "error" });
    } finally {
      setIsLoading(false);
    }
  };

  const getLink = async () => {
    setLoadingLink(true);
    try {
      const { data } = await api.get("/customers/url-fone");
      setLink(data.url);
    } catch (error) {
    } finally {
      setLoadingLink(false);
    }
  };

  useEffect(() => {
    getLink();
  }, []);

  return (
    <GetLayout>
      <Flex w="100%" mb="15px">
        <PartnersSearch
          selectedCustomer={selectedCustomer}
          setIsLoading={setIsLoading}
          isLoading={isLoading}
          onChangePartner={loadServices}
          defaultCustomerId={partnerId ? Number(partnerId) : null}
        />
        {selectedCustomer.id === user.userData.customerId ? (
          <Box w="360px">
            <Text mb="8px">Link prospecção</Text>
            <Flex>
              <Flex
                border="1px solid var(--chakra-colors-custom-gray)"
                borderRadius="0.375rem 0 0 0.375rem"
                w="100%"
                h="32px"
              >
                <InputField
                  value={link}
                  isReadyOnly
                  inputProps={{ border: "none !important" }}
                />
              </Flex>
              <IconButtonWithLoading
                aria-label="Copiar link"
                tooltipMessage="Copiar link"
                icon={<CopyIcon />}
                h="32px"
                borderRadius="0 0.375rem 0.375rem 0"
                isLoading={loadingLink}
                onClick={async () => {
                  await navigator.clipboard.writeText(link);
                  Toast({
                    title: "Link copiado com sucesso!",
                    status: "info",
                  });
                }}
              />
            </Flex>
          </Box>
        ) : null}
      </Flex>
      <Grid
        templateColumns={{
          base: "1fr",
          md: "1fr 1fr",
          xl: "1fr 1fr 1fr",
          "2xl": "1fr 1fr 1fr 1fr",
        }}
        gap={{ base: "16px", "2xl": "36px" }}
      >
        <ServiceCard
          selectedPartner={selectedCustomer}
          title="Higienização Refin"
          priceDesc="R$ 19,90 mensal (ou R$ 0,05 por consulta)"
          serviceData={serviceData}
          setServiceData={setServiceData}
          field="servicesDatafast"
          bgIcon={<BankBgIcon />}
          isLoading={isLoading}
          containerProps={{ gridArea: "span 2 / auto" }}
        />

        <ServiceCard
          selectedPartner={selectedCustomer}
          title="Geração Mailing"
          priceDesc="R$ 0,0025 por lead"
          serviceData={serviceData}
          setServiceData={setServiceData}
          field="geracaoMailing"
          bgIcon={<DocumentBgIcon />}
          isLoading={isLoading}
        />
        <ServiceCard
          selectedPartner={selectedCustomer}
          title="Consulta Offline"
          priceDesc="R$ 0,015 por consulta"
          serviceData={serviceData}
          setServiceData={setServiceData}
          field="consultaOffline"
          bgIcon={<DocumentBgIcon />}
          isLoading={isLoading}
        />

        <ServiceCard
          selectedPartner={selectedCustomer}
          title="Consulta HOT"
          priceDesc="R$ 0,30 por consulta"
          serviceData={serviceData}
          setServiceData={setServiceData}
          field="in100"
          bgIcon={<DocumentBgIcon />}
          isLoading={isLoading}
        />

        <ServiceCard
          selectedPartner={selectedCustomer}
          title="Higienização Telefones"
          priceDesc="R$ 0,08 por consulta"
          serviceData={serviceData}
          setServiceData={setServiceData}
          field="telefonia"
          bgIcon={<PhoneBgIcon />}
          isLoading={isLoading}
        />

        <ServiceCard
          selectedPartner={selectedCustomer}
          title="Consulta Saque Complementar"
          priceDesc="R$ 19,90 mensal (ou R$ 0,05 por consulta)"
          serviceData={serviceData}
          setServiceData={setServiceData}
          field="servicesAPICartaoBancoDTO"
          bgIcon={<CardBgIcon />}
          isLoading={isLoading}
        />

        <ServiceCard
          selectedPartner={selectedCustomer}
          title="Envio SMS"
          priceDesc="R$ 0,15 por envio"
          serviceData={serviceData}
          setServiceData={setServiceData}
          field="sms"
          bgIcon={<TalkBallonBgIcon />}
          isLoading={isLoading}
        />

        {/* <ServiceCard
          selectedPartner={selectedCustomer}
          title="Extrato"
          priceDesc="R$ 4,00 por extrato"
          field="extratoOnline"
          serviceData={serviceData}
          setServiceData={setServiceData}
          bgIcon={<DocumentBgIcon />}
          isLoading={isLoading}
        /> */}
        <WhatsAppServiceCard
          isLoading={isLoading}
          title="Sessões WhatsApp"
          priceDesc="R$ 15,00 mensal (por sessão)"
          serviceData={serviceData}
          selectedCustomer={selectedCustomer}
        />
        <SimulacaoFGTSServiceCard
          isLoading={loadingApiCarteira || isLoading}
          title="Simulacao FGTS"
          priceDesc="R$ 0,10 avulso"
          serviceData={cardData}
          selectedCustomer={selectedCustomer}
          setCardData={setCardData}
        />
        {[
          1, 1775, 1950, 1621, 5803, 8370, 6453, 2627, 6364, 10713, 7882, 2335,
          10276, 6630, 11024, 404, 3371, 4498, 6114, 5014, 10269, 62, 23, 11930,
          2390, 6577,
        ].includes(user.userData.customerId!) ? (
          <MargemConvênioServiceCard
            isLoading={isLoading}
            title="Margem Convênio"
            priceDesc="R$ 350,00 p/ quantidade de 15000"
            serviceData={serviceData}
            selectedCustomer={selectedCustomer}
          />
        ) : null}
        <VendeAICard
          isLoading={loadingApiCarteira || isLoading}
          title="Inteligência Artificial VendeAI"
          priceDesc="Teste Gratuito"
          serviceData={cardData}
          selectedCustomer={selectedCustomer}
          setCardData={setCardData}
        />
      </Grid>
      <ModalAtivoStatus />
      <ModalChangeCobranca />
    </GetLayout>
  );
}
